import React, { Component, lazy } from 'react';
import './CostumerStory.sass';
import i18n from '../../../../../i18n';
import LazyLoad from 'react-lazyload';
const Title = lazy(() => import('../../../../component/title/Title'));
class CostumerStory extends Component {
    constructor() {
        super();
        this.state = { video: false };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(this.state) !== JSON.stringify(nextState)) {
            return true;
        }
        return false;
    }

    render() {
        var logo = require('../../../../../resources/icons/logos/observador.webp');

        var title = i18n.t('See how |Swonkie| is changing clients’ performance on social media');

        if (title.indexOf('|Swonkie|') > -1) {
            title = title.replace('|Swonkie|', '<span class = "Blue" >Swonkie</span>');
        }

        var someHtml = ` ${title} `;

        return (
            <div className="CostumerStoryArea">
                <div className="CostumerStoryTitleArea">
                    <Title size="Big" type="Secundary" html={someHtml} text="" />
                </div>
                <div className="CostumerStoryImageArea" onClick={() => this.setState({ video: true })} >
                    <div className="CostumerStoryImage">
                        {this.state.video === true ? <iframe title="videoTitle" src="https://www.youtube.com/embed/Hm5lu9dX-fM?autoplay=1&controls=0&rel=0&modestbranding=1&loop=1" frameBorder="0" /> : null}
                    </div>
                    <div className="CostumerStoryImageBackground" />
                    <div className="CostumerStoryIcon">
                        <LazyLoad offset={200} height={70}>
                            <img alt="CostumerStoryIcon" src={logo} />
                        </LazyLoad>
                    </div>
                </div>
            </div>
        );
    }
}

export default CostumerStory;
